import { useEffect, useState } from "react";
import { api } from "../lib/api.js";
import type { ReferenceAsset } from "../lib/types.js";

/**
 * Renders a reference-image thumbnail. `/api/*` is JWT-protected so a plain
 * `<img src>` can't carry the bearer token - fetch a presigned GET url through
 * `api()` first, then hand that (auth-free, time-limited) url to the `<img>`
 * (never inline SVG per INV-5).
 */
export function RefThumbnail({ projectId, asset }: { projectId: string; asset: ReferenceAsset }) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void api<{ url: string }>(`/api/projects/${projectId}/refs/${asset.assetId}/url`)
      .then((res) => {
        if (!cancelled) setUrl(res.url);
      })
      .catch(() => {
        /* thumbnail is best-effort */
      });
    return () => {
      cancelled = true;
    };
  }, [projectId, asset.assetId]);

  if (!url) {
    return (
      <div className="flex h-20 w-20 items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-xs text-gray-400 dark:border-gray-800 dark:bg-gray-800">
        ...
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={asset.label}
      className="h-20 w-20 rounded-md border border-gray-200 object-cover dark:border-gray-800"
    />
  );
}
